// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"14dbcbe4","787":"23455a43","793":"c9e4ad48","941":"13834a27","944":"0abd54d2"}[chunkId] + ".chunk.js";
};